import { Literals } from "shared/types";
import { getDuration } from "shared/utils/timeDifference";

type Props = {
  title: string;
  ticketId?: string;
  createdAt: string;
  copyTexts: Literals;
};

function TicketInfoChatMessage(props: Props) {
  const { title, ticketId, createdAt, copyTexts } = props;
  return (
    <div className="w-full max-w-full rounded-xl border border-solid border-grey-50 px-3 py-2.5 shadow-ticketInfoCard hover:bg-grey-200">
      <div className="flex items-center gap-4">
        <div className="grow pr-11">
          <div className="px-1">
            <div className="text-sm font-semibold text-dark">{title}</div>
            <div className="flex flex-wrap items-center space-x-1.5 text-xs text-grey-1100">
              <span>ID: #{ticketId || ""}</span>
              <i className="ti ti-circle-filled text-[4px] text-grey-50" />
              <span>
                {getDuration(createdAt)} {copyTexts.agoText}
              </span>
            </div>
          </div>
        </div>
        <div className="text-xl text-accent">
          <i className="ti ti-ticket" />
        </div>
      </div>
    </div>
  );
}

export default TicketInfoChatMessage;
